import React from 'react';
import {MailOutlined} from "@ant-design/icons";
import styles from './RegistrationSuccess.module.css'
import {useAppSelector} from "../../../hooks/redux";
import {getLanguage} from "../../../store/selectors/appSelector";
import {getTextByLanguage} from "../../../enums/utils/getTextByLanguage";
import {UXRegistration} from "../../../enums/UXText/UXRegistration";

const RegistrationSuccess = () => {

    const language = useAppSelector(getLanguage)


    return (
        <div className={styles.registrationSuccessWrapper}>
            <MailOutlined className={styles.mailIcon}/>
            <h1>{getTextByLanguage(UXRegistration.registrationSuccess.header, language)}</h1>
            <p>{getTextByLanguage(UXRegistration.registrationSuccess.text, language)}</p>
        </div>
    );
};

export default RegistrationSuccess;